import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, withCtx as _withCtx, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, vShow as _vShow, withDirectives as _withDirectives, vModelText as _vModelText } from "vue"

const _hoisted_1 = {
  id: "display_tab",
  class: "my-6"
}
const _hoisted_2 = { class: "tab-wrapper-primary" }
const _hoisted_3 = { class: "tab-heading-primary" }
const _hoisted_4 = { class: "flex flex-col gap-4 p-6" }
const _hoisted_5 = { class: "text-lg font-medium" }
const _hoisted_6 = { class: "grid grid-cols-4 gap-4 px-6 pb-6 desktop:grid-cols-2 laptop:grid-cols-1" }
const _hoisted_7 = { class: "flex flex-col gap-2" }
const _hoisted_8 = {
  key: 0,
  class: "text-[10px] text-gray-400 mt-0.5 ml-[42px]"
}
const _hoisted_9 = { class: "pl-4" }
const _hoisted_10 = {
  key: 0,
  class: "text-[10px] text-gray-400 mt-0.5 ml-[42px]"
}
const _hoisted_11 = { class: "pl-4 flex flex-col gap-2" }
const _hoisted_12 = {
  key: 0,
  class: "text-[10px] text-gray-400 mt-0.5 ml-[42px]"
}
const _hoisted_13 = {
  key: 1,
  class: "text-[10px] text-gray-400 mt-0.5 ml-[42px]"
}
const _hoisted_14 = {
  key: 0,
  class: "text-[10px] text-gray-400 mt-0.5 ml-[42px]"
}
const _hoisted_15 = { class: "flex flex-wrap items-center gap-x-3 gap-y-2 mt-1" }
const _hoisted_16 = { class: "text-sm text-gray-600 whitespace-nowrap" }
const _hoisted_17 = { class: "flex rounded-md border border-gray-300 overflow-hidden shrink-0" }
const _hoisted_18 = ["disabled"]
const _hoisted_19 = ["disabled"]
const _hoisted_20 = { class: "flex flex-col gap-4 p-6" }
const _hoisted_21 = { class: "text-lg font-medium mb-2" }
const _hoisted_22 = { class: "-mt-2" }
const _hoisted_23 = { class: "w-1/2" }
const _hoisted_24 = { class: "w-1/2" }
const _hoisted_25 = { class: "p-6 max-w-lg" }
const _hoisted_26 = { class: "text-lg font-medium mb-2" }
const _hoisted_27 = { class: "overflow-hidden rounded-lg border border-gray-300 shadow-sm" }
const _hoisted_28 = /*#__PURE__*/_createElementVNode("div", { class: "table-header bg-gray-200 flex" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "px-4 py-2 text-sm font-semibold text-gray-900 flex-[3] border-r border-gray-300" }, "Display Location / Element"),
  /*#__PURE__*/_createElementVNode("div", { class: "px-4 py-2 text-sm font-semibold text-gray-900 flex-1 border-r border-gray-300" }, "Specials"),
  /*#__PURE__*/_createElementVNode("div", { class: "px-4 py-2 text-sm font-semibold text-gray-900 flex-1" }, "MinLos")
], -1)
const _hoisted_29 = { class: "table-body" }
const _hoisted_30 = { class: "flex border-t border-gray-300" }
const _hoisted_31 = /*#__PURE__*/_createElementVNode("div", { class: "px-4 py-2 text-sm text-gray-900 flex-[3] flex items-center border-r border-gray-300" }, "Matrix Row Header", -1)
const _hoisted_32 = { class: "px-4 py-2 text-center flex-1 flex items-center justify-center border-r border-gray-300" }
const _hoisted_33 = { class: "px-4 py-2 text-center flex-1 flex items-center justify-center" }
const _hoisted_34 = { class: "flex border-t border-gray-300" }
const _hoisted_35 = /*#__PURE__*/_createElementVNode("div", { class: "px-4 py-2 text-sm text-gray-900 flex-[3] flex items-center border-r border-gray-300" }, "Matrix Cell", -1)
const _hoisted_36 = { class: "px-4 py-2 text-center flex-1 flex items-center justify-center border-r border-gray-300" }
const _hoisted_37 = { class: "px-4 py-2 text-center flex-1 flex items-center justify-center" }
const _hoisted_38 = { class: "flex border-t border-gray-300" }
const _hoisted_39 = /*#__PURE__*/_createElementVNode("div", { class: "px-4 py-2 text-sm text-gray-900 flex-[3] flex items-center border-r border-gray-300" }, "Search Results Button", -1)
const _hoisted_40 = { class: "px-4 py-2 text-center flex-1 flex items-center justify-center border-r border-gray-300" }
const _hoisted_41 = { class: "px-4 py-2 text-center flex-1 flex items-center justify-center" }
const _hoisted_42 = { class: "flex border-t border-gray-300" }
const _hoisted_43 = /*#__PURE__*/_createElementVNode("div", { class: "px-4 py-2 text-sm text-gray-900 flex-[3] flex items-center border-r border-gray-300" }, "Teaser Below Photo Carousel", -1)
const _hoisted_44 = { class: "px-4 py-2 text-center flex-1 flex items-center justify-center border-r border-gray-300" }
const _hoisted_45 = { class: "px-4 py-2 text-center flex-1 flex items-center justify-center" }
const _hoisted_46 = { class: "flex border-t border-gray-300" }
const _hoisted_47 = /*#__PURE__*/_createElementVNode("div", { class: "px-4 py-2 text-sm text-gray-900 flex-[3] flex items-center border-r border-gray-300" }, "Details Pop-up (Deals For You)", -1)
const _hoisted_48 = { class: "px-4 py-2 text-center flex-1 flex items-center justify-center border-r border-gray-300" }
const _hoisted_49 = { class: "px-4 py-2 text-center flex-1 flex items-center justify-center" }
const _hoisted_50 = {
  key: 1,
  id: "matrix-view",
  class: "tab-wrapper-primary mt-6"
}
const _hoisted_51 = { class: "tab-heading-primary" }
const _hoisted_52 = { class: "flex flex-col gap-4 p-6" }
const _hoisted_53 = /*#__PURE__*/_createElementVNode("div", { class: "h-px border border-dashed border-gray-300" }, null, -1)
const _hoisted_54 = { class: "flex justify-between gap-4" }
const _hoisted_55 = {
  key: 0,
  class: "relative w-1/2 mt-2"
}
const _hoisted_56 = {
  class: "label-primary",
  for: ""
}
const _hoisted_57 = ["placeholder"]
const _hoisted_58 = { key: 0 }
const _hoisted_59 = { class: "absolute top-3.5 right-3" }
const _hoisted_60 = { class: "mt-2 text-xs text-critical-main" }
const _hoisted_61 = { class: "relative w-1/2 mt-2" }
const _hoisted_62 = {
  class: "label-primary",
  for: ""
}
const _hoisted_63 = ["placeholder"]
const _hoisted_64 = { key: 0 }
const _hoisted_65 = { class: "absolute top-3.5 right-3" }
const _hoisted_66 = { class: "mt-2 text-xs text-critical-main" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_NotificationPopup = _resolveComponent("NotificationPopup")!
  const _component_SearchLayoutIcon = _resolveComponent("SearchLayoutIcon")!
  const _component_LayoutCard = _resolveComponent("LayoutCard")!
  const _component_SearchMatrixLayoutIcon = _resolveComponent("SearchMatrixLayoutIcon")!
  const _component_MatrixLayoutIcon = _resolveComponent("MatrixLayoutIcon")!
  const _component_CheckboxSlide = _resolveComponent("CheckboxSlide")!
  const _component_CardMatrixLayoutIcon = _resolveComponent("CardMatrixLayoutIcon")!
  const _component_EditableDropdown = _resolveComponent("EditableDropdown")!
  const _component_BaseCheckbox = _resolveComponent("BaseCheckbox")!
  const _component_DropdownMenu = _resolveComponent("DropdownMenu")!
  const _component_ErrorIcon = _resolveComponent("ErrorIcon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.widget.edited)
      ? (_openBlock(), _createBlock(_component_NotificationPopup, {
          key: 0,
          status: "warning",
          title: "Changes Unpublished",
          text: "To view your updates on the widget, please save and publish them.",
          class: "mb-6"
        }))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.changeCase('display', _ctx.ElementE.TITLE)), 1),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("h4", _hoisted_5, _toDisplayString(_ctx.changeCase('layout', _ctx.ElementE.TITLE)), 1)
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createVNode(_component_LayoutCard, {
          id: "search",
          label: (_ctx.changeCase('search', _ctx.ElementE.LABEL) as string),
          isSelected: _ctx.search,
          onSelect: _ctx.selectLayout
        }, {
          icon: _withCtx(() => [
            _createVNode(_component_SearchLayoutIcon)
          ]),
          _: 1
        }, 8, ["label", "isSelected", "onSelect"]),
        _createVNode(_component_LayoutCard, {
          id: "matrixSearch",
          label: (_ctx.changeCase('search & matrix', _ctx.ElementE.LABEL) as string),
          isSelected: _ctx.matrixSearch,
          onSelect: _ctx.selectLayout
        }, {
          icon: _withCtx(() => [
            _createVNode(_component_SearchMatrixLayoutIcon)
          ]),
          _: 1
        }, 8, ["label", "isSelected", "onSelect"]),
        _createVNode(_component_LayoutCard, {
          id: "matrix",
          label: (_ctx.changeCase('matrix', _ctx.ElementE.LABEL) as string),
          isSelected: _ctx.matrix,
          onSelect: _ctx.selectLayout
        }, {
          icon: _withCtx(() => [
            _createVNode(_component_MatrixLayoutIcon)
          ]),
          extra: _withCtx(() => [
            _createVNode(_component_CheckboxSlide, {
              label: "Display matrix on mobile",
              disabled: !_ctx.matrix,
              isChecked: _ctx.displayMatrixOnMobile,
              size: "xs",
              "onUpdate:isChecked": _ctx.enableDisplayMatrixOnMobile
            }, null, 8, ["disabled", "isChecked", "onUpdate:isChecked"])
          ]),
          _: 1
        }, 8, ["label", "isSelected", "onSelect"]),
        _createVNode(_component_LayoutCard, {
          id: "cardMatrix",
          label: (_ctx.changeCase('card matrix', _ctx.ElementE.LABEL) as string),
          isSelected: _ctx.cardMatrix,
          onSelect: _ctx.selectLayout
        }, {
          icon: _withCtx(() => [
            _createVNode(_component_CardMatrixLayoutIcon, { layout: _ctx.cardMatrixRoomLayout }, null, 8, ["layout"])
          ]),
          extra: _withCtx(() => [
            _createElementVNode("div", _hoisted_7, [
              _createVNode(_component_CheckboxSlide, {
                label: (_ctx.changeCase('show search bar', _ctx.ElementE.LABEL) as string),
                disabled: !_ctx.cardMatrix,
                isChecked: _ctx.cardMatrixShowSearch,
                size: "xs",
                "onUpdate:isChecked": _ctx.toggleCardMatrixShowSearch
              }, null, 8, ["label", "disabled", "isChecked", "onUpdate:isChecked"]),
              _createElementVNode("div", null, [
                _createVNode(_component_CheckboxSlide, {
                  label: (_ctx.changeCase('show property boards on load', _ctx.ElementE.LABEL) as string),
                  disabled: !_ctx.cardMatrix || !_ctx.cardMatrixShowSearch,
                  isChecked: _ctx.cardMatrixShowPropertyBoards,
                  size: "xs",
                  "onUpdate:isChecked": _ctx.toggleCardMatrixShowPropertyBoards
                }, null, 8, ["label", "disabled", "isChecked", "onUpdate:isChecked"]),
                (_ctx.cardMatrix && !_ctx.cardMatrixShowSearch)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_8, _toDisplayString(_ctx.changeCase('required when the search bar is hidden', _ctx.ElementE.LABEL)), 1))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_9, [
                _createVNode(_component_CheckboxSlide, {
                  label: (_ctx.changeCase('show teaser text before search', _ctx.ElementE.LABEL) as string),
                  disabled: !_ctx.cardMatrix || _ctx.cardMatrixShowPropertyBoards,
                  isChecked: _ctx.cardMatrixShowTeaserText,
                  size: "xs",
                  "onUpdate:isChecked": _ctx.toggleCardMatrixShowTeaserText
                }, null, 8, ["label", "disabled", "isChecked", "onUpdate:isChecked"]),
                (_ctx.cardMatrix && _ctx.cardMatrixShowPropertyBoards)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_10, _toDisplayString(_ctx.changeCase('not available when property boards are shown on load', _ctx.ElementE.LABEL)), 1))
                  : _createCommentVNode("", true)
              ]),
              _createVNode(_component_CheckboxSlide, {
                label: (_ctx.changeCase('show availability matrix', _ctx.ElementE.LABEL) as string),
                disabled: !_ctx.cardMatrix,
                isChecked: _ctx.cardMatrixShowMatrix,
                size: "xs",
                "onUpdate:isChecked": _ctx.toggleCardMatrixShowMatrix
              }, null, 8, ["label", "disabled", "isChecked", "onUpdate:isChecked"]),
              _createElementVNode("div", _hoisted_11, [
                _createVNode(_component_CheckboxSlide, {
                  label: (_ctx.changeCase('open matrix when card expands', _ctx.ElementE.LABEL) as string),
                  disabled: !_ctx.cardMatrix || !_ctx.cardMatrixShowMatrix,
                  isChecked: _ctx.cardMatrixShowMatrixOnLoad,
                  size: "xs",
                  "onUpdate:isChecked": _ctx.toggleCardMatrixShowMatrixOnLoad
                }, null, 8, ["label", "disabled", "isChecked", "onUpdate:isChecked"]),
                _createVNode(_component_CheckboxSlide, {
                  label: (_ctx.changeCase('show prices in matrix', _ctx.ElementE.LABEL) as string),
                  disabled: !_ctx.cardMatrix || !_ctx.cardMatrixShowMatrix || (_ctx.cardMatrixShowPrices && !_ctx.cardMatrixShowRoomCount),
                  isChecked: _ctx.cardMatrixShowPrices,
                  size: "xs",
                  "onUpdate:isChecked": _ctx.toggleCardMatrixShowPrices
                }, null, 8, ["label", "disabled", "isChecked", "onUpdate:isChecked"]),
                _createVNode(_component_CheckboxSlide, {
                  label: (_ctx.changeCase('show room count in matrix', _ctx.ElementE.LABEL) as string),
                  disabled: !_ctx.cardMatrix || !_ctx.cardMatrixShowMatrix || (_ctx.cardMatrixShowRoomCount && !_ctx.cardMatrixShowPrices),
                  isChecked: _ctx.cardMatrixShowRoomCount,
                  size: "xs",
                  "onUpdate:isChecked": _ctx.toggleCardMatrixShowRoomCount
                }, null, 8, ["label", "disabled", "isChecked", "onUpdate:isChecked"]),
                (_ctx.cardMatrix && _ctx.cardMatrixShowMatrix && (!_ctx.cardMatrixShowPrices || !_ctx.cardMatrixShowRoomCount))
                  ? (_openBlock(), _createElementBlock("p", _hoisted_12, _toDisplayString(_ctx.changeCase('prices or room count must stay on so matrix cells are not empty', _ctx.ElementE.LABEL)), 1))
                  : _createCommentVNode("", true),
                _createVNode(_component_CheckboxSlide, {
                  label: (_ctx.changeCase('show sold-out label in matrix', _ctx.ElementE.LABEL) as string),
                  disabled: !_ctx.cardMatrix || !_ctx.cardMatrixShowMatrix,
                  isChecked: _ctx.cardMatrixShowAvailabilityText,
                  size: "xs",
                  "onUpdate:isChecked": _ctx.toggleCardMatrixShowAvailabilityText
                }, null, 8, ["label", "disabled", "isChecked", "onUpdate:isChecked"]),
                _createVNode(_component_CheckboxSlide, {
                  label: (_ctx.changeCase('start matrix collapsed on mobile', _ctx.ElementE.LABEL) as string),
                  disabled: !_ctx.cardMatrix || !_ctx.cardMatrixShowMatrix,
                  isChecked: _ctx.cardMatrixMobileDefaultCollapsed,
                  size: "xs",
                  "onUpdate:isChecked": _ctx.toggleCardMatrixMobileDefaultCollapsed
                }, null, 8, ["label", "disabled", "isChecked", "onUpdate:isChecked"]),
                (_ctx.cardMatrix && !_ctx.cardMatrixShowMatrix)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_13, _toDisplayString(_ctx.changeCase('not available when the availability matrix is hidden', _ctx.ElementE.LABEL)), 1))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", null, [
                _createVNode(_component_CheckboxSlide, {
                  label: (_ctx.changeCase('pre-load properties', _ctx.ElementE.LABEL) as string),
                  disabled: !_ctx.cardMatrix || !_ctx.cardMatrixShowSearch,
                  isChecked: _ctx.cardMatrixPreloadProperties,
                  size: "xs",
                  "onUpdate:isChecked": _ctx.toggleCardMatrixPreloadProperties
                }, null, 8, ["label", "disabled", "isChecked", "onUpdate:isChecked"]),
                (_ctx.cardMatrix && !_ctx.cardMatrixShowSearch)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_14, _toDisplayString(_ctx.changeCase('required when the search bar is hidden', _ctx.ElementE.LABEL)), 1))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_15, [
                _createElementVNode("span", _hoisted_16, _toDisplayString(_ctx.changeCase('room card layout', _ctx.ElementE.LABEL)), 1),
                _createElementVNode("div", _hoisted_17, [
                  _createElementVNode("button", {
                    class: _normalizeClass(["px-3 py-1 text-xs font-medium transition-colors", _ctx.cardMatrixRoomLayout === 'horizontal'
                      ? 'bg-black text-white'
                      : 'bg-white text-gray-700 hover:bg-gray-50']),
                    disabled: !_ctx.cardMatrix,
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.setCardMatrixRoomLayout('horizontal')))
                  }, _toDisplayString(_ctx.changeCase('horizontal', _ctx.ElementE.BUTTON)), 11, _hoisted_18),
                  _createElementVNode("button", {
                    class: _normalizeClass(["px-3 py-1 text-xs font-medium transition-colors border-l border-gray-300", _ctx.cardMatrixRoomLayout === 'vertical'
                      ? 'bg-black text-white'
                      : 'bg-white text-gray-700 hover:bg-gray-50']),
                    disabled: !_ctx.cardMatrix,
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.setCardMatrixRoomLayout('vertical')))
                  }, _toDisplayString(_ctx.changeCase('vertical', _ctx.ElementE.BUTTON)), 11, _hoisted_19)
                ])
              ]),
              _createVNode(_component_CheckboxSlide, {
                label: (_ctx.changeCase('show pricing teaser on room cards', _ctx.ElementE.LABEL) as string),
                disabled: !_ctx.cardMatrix,
                isChecked: _ctx.cardMatrixShowTeaserPricing,
                size: "xs",
                "onUpdate:isChecked": _ctx.toggleCardMatrixShowTeaserPricing
              }, null, 8, ["label", "disabled", "isChecked", "onUpdate:isChecked"]),
              _createVNode(_component_CheckboxSlide, {
                label: (_ctx.changeCase('hide rates inside room cards', _ctx.ElementE.LABEL) as string),
                disabled: !_ctx.cardMatrix,
                isChecked: _ctx.cardMatrixRoomCardHideRates,
                size: "xs",
                "onUpdate:isChecked": _ctx.toggleCardMatrixRoomCardHideRates
              }, null, 8, ["label", "disabled", "isChecked", "onUpdate:isChecked"])
            ])
          ]),
          _: 1
        }, 8, ["label", "isSelected", "onSelect"])
      ]),
      _createElementVNode("div", _hoisted_20, [
        _createElementVNode("h4", _hoisted_21, _toDisplayString(_ctx.changeCase('widget customisation', _ctx.ElementE.TITLE)), 1),
        _createElementVNode("div", _hoisted_22, [
          _createVNode(_component_CheckboxSlide, {
            label: "Show Property Filter",
            disabled: !_ctx.search && !_ctx.matrixSearch,
            isChecked: _ctx.showPropertyFilter,
            size: "xs",
            "onUpdate:isChecked": _ctx.enableShowPropertyFilter
          }, null, 8, ["disabled", "isChecked", "onUpdate:isChecked"])
        ]),
        _createElementVNode("div", _hoisted_23, [
          _createVNode(_component_EditableDropdown, {
            values: _ctx.showDays,
            defaultValue: String(_ctx.widget.config?.display_days || 7),
            label: "Matrix Display Days",
            placeholder: "Enter days or select from list",
            class: "z-20",
            min: 1,
            max: 15,
            validateAsNumber: true,
            onSelect: _ctx.changeDisplayDays
          }, null, 8, ["values", "defaultValue", "onSelect"])
        ]),
        _createElementVNode("div", _hoisted_24, [
          _createVNode(_component_EditableDropdown, {
            values: _ctx.showDays,
            defaultValue: String(_ctx.widget.config?.default_night_count || 7),
            label: "Default Night Count",
            placeholder: "Enter nights or select from list",
            min: 1,
            max: 15,
            validateAsNumber: true,
            onSelect: _ctx.changeDefaultNightCount
          }, null, 8, ["values", "defaultValue", "onSelect"])
        ])
      ]),
      _createElementVNode("section", _hoisted_25, [
        _createElementVNode("h4", _hoisted_26, _toDisplayString(_ctx.changeCase('"deals for you" display settings', _ctx.ElementE.TITLE)), 1),
        _createElementVNode("div", _hoisted_27, [
          _hoisted_28,
          _createElementVNode("div", _hoisted_29, [
            _withDirectives(_createElementVNode("div", _hoisted_30, [
              _hoisted_31,
              _createElementVNode("div", _hoisted_32, [
                _createVNode(_component_BaseCheckbox, {
                  checked: _ctx.dealsSettings.specials.matrix_row_header,
                  disabled: !_ctx.isSpecialsEnabled,
                  "onUpdate:checked": _cache[2] || (_cache[2] = ($event: any) => (_ctx.updateDealsSettings($event, _ctx.DealsSettingsType.SPECIALS, _ctx.DealsSettingsLocation.MATRIX_ROW_HEADER)))
                }, null, 8, ["checked", "disabled"])
              ]),
              _createElementVNode("div", _hoisted_33, [
                _createVNode(_component_BaseCheckbox, {
                  checked: _ctx.dealsSettings.minlos.matrix_row_header,
                  "onUpdate:checked": _cache[3] || (_cache[3] = ($event: any) => (_ctx.updateDealsSettings($event, _ctx.DealsSettingsType.MINLOS, _ctx.DealsSettingsLocation.MATRIX_ROW_HEADER)))
                }, null, 8, ["checked"])
              ])
            ], 512), [
              [_vShow, !_ctx.search]
            ]),
            _withDirectives(_createElementVNode("div", _hoisted_34, [
              _hoisted_35,
              _createElementVNode("div", _hoisted_36, [
                _createVNode(_component_BaseCheckbox, {
                  checked: _ctx.dealsSettings.specials.matrix_cell,
                  disabled: !_ctx.isSpecialsEnabled,
                  "onUpdate:checked": _cache[4] || (_cache[4] = ($event: any) => (_ctx.updateDealsSettings($event, _ctx.DealsSettingsType.SPECIALS, _ctx.DealsSettingsLocation.MATRIX_CELL)))
                }, null, 8, ["checked", "disabled"])
              ]),
              _createElementVNode("div", _hoisted_37, [
                _createVNode(_component_BaseCheckbox, {
                  checked: _ctx.dealsSettings.minlos.matrix_cell,
                  "onUpdate:checked": _cache[5] || (_cache[5] = ($event: any) => (_ctx.updateDealsSettings($event, _ctx.DealsSettingsType.MINLOS, _ctx.DealsSettingsLocation.MATRIX_CELL)))
                }, null, 8, ["checked"])
              ])
            ], 512), [
              [_vShow, !_ctx.search]
            ]),
            _createElementVNode("div", _hoisted_38, [
              _hoisted_39,
              _createElementVNode("div", _hoisted_40, [
                _createVNode(_component_BaseCheckbox, {
                  checked: _ctx.dealsSettings.specials.search_results_button,
                  disabled: !_ctx.isSpecialsEnabled,
                  "onUpdate:checked": _cache[6] || (_cache[6] = ($event: any) => (_ctx.updateDealsSettings($event, _ctx.DealsSettingsType.SPECIALS, _ctx.DealsSettingsLocation.SEARCH_RESULTS_BUTTON)))
                }, null, 8, ["checked", "disabled"])
              ]),
              _createElementVNode("div", _hoisted_41, [
                _createVNode(_component_BaseCheckbox, {
                  checked: _ctx.dealsSettings.minlos.search_results_button,
                  "onUpdate:checked": _cache[7] || (_cache[7] = ($event: any) => (_ctx.updateDealsSettings($event, _ctx.DealsSettingsType.MINLOS, _ctx.DealsSettingsLocation.SEARCH_RESULTS_BUTTON)))
                }, null, 8, ["checked"])
              ])
            ]),
            _createElementVNode("div", _hoisted_42, [
              _hoisted_43,
              _createElementVNode("div", _hoisted_44, [
                _createVNode(_component_BaseCheckbox, {
                  checked: _ctx.dealsSettings.specials.teaser_below_photo_carousel,
                  disabled: true,
                  "onUpdate:checked": _cache[8] || (_cache[8] = ($event: any) => (_ctx.updateDealsSettings($event, _ctx.DealsSettingsType.SPECIALS, _ctx.DealsSettingsLocation.TEASER_BELOW_PHOTO_CAROUSEL)))
                }, null, 8, ["checked"])
              ]),
              _createElementVNode("div", _hoisted_45, [
                _createVNode(_component_BaseCheckbox, {
                  checked: _ctx.dealsSettings.minlos.teaser_below_photo_carousel,
                  "onUpdate:checked": _cache[9] || (_cache[9] = ($event: any) => (_ctx.updateDealsSettings($event, _ctx.DealsSettingsType.MINLOS, _ctx.DealsSettingsLocation.TEASER_BELOW_PHOTO_CAROUSEL)))
                }, null, 8, ["checked"])
              ])
            ]),
            _createElementVNode("div", _hoisted_46, [
              _hoisted_47,
              _createElementVNode("div", _hoisted_48, [
                _createVNode(_component_BaseCheckbox, {
                  checked: _ctx.dealsSettings.specials.details_pop_up,
                  disabled: !_ctx.isSpecialsEnabled,
                  "onUpdate:checked": _cache[10] || (_cache[10] = ($event: any) => (_ctx.updateDealsSettings($event, _ctx.DealsSettingsType.SPECIALS, _ctx.DealsSettingsLocation.DETAILS_POP_UP)))
                }, null, 8, ["checked", "disabled"])
              ]),
              _createElementVNode("div", _hoisted_49, [
                _createVNode(_component_BaseCheckbox, {
                  checked: _ctx.dealsSettings.minlos.details_pop_up,
                  "onUpdate:checked": _cache[11] || (_cache[11] = ($event: any) => (_ctx.updateDealsSettings($event, _ctx.DealsSettingsType.MINLOS, _ctx.DealsSettingsLocation.DETAILS_POP_UP)))
                }, null, 8, ["checked"])
              ])
            ])
          ])
        ])
      ])
    ]),
    (_ctx.showMatrixView)
      ? (_openBlock(), _createElementBlock("div", _hoisted_50, [
          _createElementVNode("div", _hoisted_51, _toDisplayString(_ctx.changeCase('customise matrix', _ctx.ElementE.TITLE)), 1),
          _createElementVNode("div", _hoisted_52, [
            _createVNode(_component_CheckboxSlide, {
              class: "z-30",
              "is-checked": _ctx.showPropertyThumbnail,
              onChange: _ctx.showPropThumbnailChange,
              info: "some info",
              label: "show property thumbnail",
              tooltipTxt: "Display a small preview image of the property displayed alongside its details."
            }, null, 8, ["is-checked", "onChange"]),
            _hoisted_53,
            (_ctx.widget.config?.matrix_mode)
              ? (_openBlock(), _createBlock(_component_DropdownMenu, {
                  key: 0,
                  values: _ctx.showVariant,
                  defaultSelect: _ctx.MatrixDisplayDetailsE[_ctx.widget.config?.matrix_mode as keyof typeof MatrixDisplayDetailsE] || 'Select value',
                  label: "Matrix display details",
                  onSelect: _ctx.showAviableField
                }, null, 8, ["values", "defaultSelect", "onSelect"]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_54, [
              (_ctx.showAviable)
                ? (_openBlock(), _createElementBlock("div", _hoisted_55, [
                    _createElementVNode("label", _hoisted_56, _toDisplayString(_ctx.changeCase('available text', _ctx.ElementE.LABEL)), 1),
                    _withDirectives(_createElementVNode("input", {
                      onChange: _cache[12] || (_cache[12] = 
//@ts-ignore
(...args) => (_ctx.updateWidget && _ctx.updateWidget(...args))),
                      "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.widget.config.available_text) = $event)),
                      class: _normalizeClass(["input-primary", 
                _ctx.errors.availableText && 'border-critical'
              ]),
                      type: "text",
                      placeholder: (_ctx.changeCase('enter text', _ctx.ElementE.PLACEHOLDER) as string),
                      onBlur: _cache[14] || (_cache[14] = ($event: any) => (
                _ctx.validateField('availableText', _ctx.widget.config.available_text)
              ))
                    }, null, 42, _hoisted_57), [
                      [
                        _vModelText,
                        _ctx.widget.config.available_text,
                        void 0,
                        { trim: true }
                      ]
                    ]),
                    (_ctx.errors.availableText)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_58, [
                          _createElementVNode("div", _hoisted_59, [
                            _createVNode(_component_ErrorIcon)
                          ]),
                          _createElementVNode("p", _hoisted_60, _toDisplayString(_ctx.errors.availableText), 1)
                        ]))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_61, [
                _createElementVNode("label", _hoisted_62, _toDisplayString(_ctx.changeCase('text when no rooms available', _ctx.ElementE.LABEL)), 1),
                _withDirectives(_createElementVNode("input", {
                  onChange: _cache[15] || (_cache[15] = 
//@ts-ignore
(...args) => (_ctx.updateWidget && _ctx.updateWidget(...args))),
                  "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.widget.config.unavailable_text) = $event)),
                  class: _normalizeClass(["input-primary", 
                _ctx.errors.unavailableText && 'border-critical'
              ]),
                  type: "text",
                  placeholder: (_ctx.changeCase('enter text', _ctx.ElementE.PLACEHOLDER) as string),
                  onBlur: _cache[17] || (_cache[17] = ($event: any) => (
                _ctx.validateField('unavailableText', _ctx.widget.config.unavailable_text)
              ))
                }, null, 42, _hoisted_63), [
                  [
                    _vModelText,
                    _ctx.widget.config.unavailable_text,
                    void 0,
                    { trim: true }
                  ]
                ]),
                (_ctx.errors.unavailableText)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_64, [
                      _createElementVNode("div", _hoisted_65, [
                        _createVNode(_component_ErrorIcon)
                      ]),
                      _createElementVNode("p", _hoisted_66, _toDisplayString(_ctx.errors.unavailableText), 1)
                    ]))
                  : _createCommentVNode("", true)
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}